import React from "react";
import type { TradeInAemSearchType } from "../../../utils/constants";
import useFindVehicleSearch from "../../../hooks/useFindVehicleSearch";
import * as Form from "../common/styles/FormsAem";
import Icon, { IconExclamation } from "../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { useTradeInAemSelector } from "../../../redux/store";
import { useTradeInAemLabel } from "../../../utils/labels";
import { trackStartSearch } from "../../../utils/tracking";
import useTrackingParams from "../../../hooks/useTrackingParams";
import { TradeInAemFindVehicleStatus } from "../../../utils/types";

const FindVehicleSearch = (props: { type: TradeInAemSearchType }): JSX.Element => {
    const { type } = props;
    const searchLoading = useTradeInAemSelector(
        (state) => state.tradeInAemFindVehicle.searchStatus === TradeInAemFindVehicleStatus.Loading,
    );
    const resolveLoading = useTradeInAemSelector((state) => state.tradeInAemFindVehicle.resolveLoading);
    const loadingLabel = useTradeInAemLabel("tradeInAemLoading");
    const { searchValue, setSearchValue, findVehicle, labels, error } = useFindVehicleSearch(type);
    const trackingParams = useTrackingParams();
    const { titleLabel, descriptionLabel, placeholderLabel } = labels;
    const loading = searchLoading || resolveLoading;

    return (
        <div>
            <Form.Label>
                {titleLabel}
                <Form.MandatoryField largeFontSize>*</Form.MandatoryField>
            </Form.Label>
            <form
                onSubmit={(event) => {
                    // Added this form wrapper and submit as a small DX/UX improvement as this allows searching by pressing enter.
                    event.preventDefault();
                    findVehicle();
                }}
            >
                <Form.InputWrapper hasIcon>
                    <input
                        placeholder={placeholderLabel}
                        value={searchValue}
                        onChange={(event) => {
                            setSearchValue(event.target.value);
                        }}
                        onFocus={!searchValue ? () => trackStartSearch(trackingParams, type) : undefined}
                        disabled={loading}
                    />
                    <Form.InputWrapperIcon type="submit">
                        <Icon variant="search" />
                    </Form.InputWrapperIcon>
                </Form.InputWrapper>
            </form>
            <Form.HelpText>{searchLoading ? loadingLabel : descriptionLabel}</Form.HelpText>
            {error && (
                <Form.Error>
                    <span>{error}</span>
                    <IconWrapper iconColor="primaryRed">
                        <IconExclamation />
                    </IconWrapper>
                </Form.Error>
            )}
        </div>
    );
};
export default FindVehicleSearch;
